import { NavCard } from "@Components/game";
import GameCardGrid from "@Components/game/game-card-grid";
import { Actions, AppContext } from "@Context/common/general/context";

import ContainerWrapper from "@Components/generic/container-wrapper";
import AccountAuthorizations from "@Enums/AccountAuthorizations";
import { faGoalNet, faList, faStopwatch } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import useAuthorizations from "@hooks/common/general/use-authorizations";
import { Container, useTheme } from "@mui/material";
import { useContext } from "react";

const PageId = "COACH";

const Train = () => {
  const { state, dispatch } = useContext(AppContext);
  const theme = useTheme();
  const { i18n } = useI18n();

  const { BYBCAT_ACCESS, CUSTOM_PLAYLISTS, EDITOR_ACCESS } = useAuthorizations([
    AccountAuthorizations.BYBCAT_ACCESS,
    AccountAuthorizations.CUSTOM_PLAYLISTS,
    AccountAuthorizations.EDITOR_ACCESS,
  ]);

  const navigate = (path: string, nextPage: string, dir = "LEFT") => {
    dispatch({
      type: Actions.AppActions.Navigate,
      payload: {
        from_page: PageId,
        to_page: nextPage,
        path: path,
        direction: dir,
      },
    });
  };

  return (
    <ContainerWrapper id={PageId}>
      <Container maxWidth={false} disableGutters sx={{ padding: theme.spacing(6) }}>
        <GameCardGrid>
          <NavCard
            title={i18n("coach.custom-playlists.title")}
            description={i18n("coach.custom-playlists.description")}
            tag={i18n("coach.club-feature")}
            icon={faList}
            disabled={!CUSTOM_PLAYLISTS}
            onClick={() => state.app.events.navigate.emit({ path: "/coach/playlists" })}
          />
          <NavCard
            title={i18n("coach.scenario-editor.title")}
            description={i18n("coach.scenario-editor.description")}
            tag={i18n("coach.club-feature")}
            icon={faGoalNet}
            disabled={!EDITOR_ACCESS}
            onClick={() => state.app.events.navigate.emit({ path: "/coach/360/scenario-editor" })}
          />
          <NavCard
            title="BYBCAT"
            description={i18n("coach.bybcat.description")}
            tag={i18n("coach.club-feature")}
            icon={faStopwatch}
            disabled={!BYBCAT_ACCESS}
            onClick={() => state.app.events.navigate.emit({ path: "/coach/bybcat" })}
          />
        </GameCardGrid>
      </Container>
    </ContainerWrapper>
  );
};

export default Train;
